import React, { Component } from 'react'
import FilterActiveIcon from "../../icons/filteractiveicon";
import FilterIcon from "../../icons/filtericon";
import moment from 'moment-timezone'
import ReactPaginate from "react-paginate";
import TextField from '../TextField';

import DatePicker from 'react-datepicker';
import CalendarIcon from '../../icons/calendaricon';
import service from '../../services';
import { data } from 'jquery';
import Loader from '../loader';
import serachIcon from './../../assets/images/search.svg'
import { ActCreators } from '../../redux/bindActionCretor';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
let description
let itemsWiseFilterData = [];
let roleWiseFilterData = [];
let FilmTypeFilterData=[];
let locationFilter=[];
let screeningTypeFilterData = [];
let sourceFilterData = [];
let sub;
let count = 0;
let notScannedcount = 0;
let ScanCount=0;
const mapStateToProps = state => ({
    Searchvalue: state.Searchvalue,
    searchLocation: state.searchLocation
  });
  
  const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch);
  };
 class TheaterDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fromDate: new Date(),
            toDate: new Date(),
            // dateFilterModal: false,
            purchaseReceipt: false,
            dateTimeFilterModal:false,
            // dateDisplayFlag: false,
            // dateState: false,
            Datetime:false,
            TheaterDatetimeFlag:false,
            TheaterDatetime:false,
            getAllUserActivities: [],
            purchaseList: [],
            searchField: '',
            searchFilm:'',
            searchLocation:'',
            searchFilmField: '',
            OrignalData: [],
            LocationData:[],
            typingTimeout: 0,
            rolesType: [
                { assign: "sioUser", name: "Industry", value: false },
                { assign: "pressUser", name: "Press", value: false },
                // { assign: "circleUser", name: "Sundance Circle", value: false },
                { assign: 'generalUser', name: 'General', value: false },
                { assign: 'circleGuestUser', name: 'Sundance Guest', value: false },
                { assign: 'artistUser', name: 'Artist', value: false },
            ],
            screeningType: [
                { assign: "1", name: "Premiere", value: false },
                { assign: "2", name: "Second Screening", value: false },
                { assign: "3", name: "Award Winner", value: false },
                { assign: "4", name: "Private Screening", value: false },
                // { assign: '4', name: 'Indies Series', value: false },
                // { assign: '5', name: 'Short Program', value: false },
            ],
            // pagination variable diclaration start
            offset: 0,
            perPage: 50,
            currentPage: 0,
            totalPages: 0,
            counts:0,
            notcounts:0,

            scancount:0,
            // pagination variable diclaration end
            activetab: 2,
            userlist: [
                { "label": "Talks & Events" },
                { "label": "Theater Details" },
                { "label": "Online Screenings" },
                { "label": "Voting" },
                { "label": "Product Sales" },
                // { "label": "Reservations" },
                { "label": "Purchases" },
            ]
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        roleWiseFilterData = [];
        FilmTypeFilterData=[];
        screeningTypeFilterData = [];
        sourceFilterData = [];
        locationFilter=[];
        count = 0
       
    }

    componentDidMount = async () => {
        const { getLoginAdminByID, getLoginRole } = this.props
        this.apiserve.sendevent("admin|getFilmTitles", {});
        this.apiserve.sendevent("location|exploreList", {});
        // locationFilter = this.apiserve.sendevent("location|getList", {})
        let currentPage = localStorage.getItem('currentPage')
        if(currentPage) {
        this.setState({
        //   offset: parseInt(localStorage.getItem("offset")),
        //   perPage: parseInt(localStorage.getItem("perPage")),
        //   currentPage: parseInt(localStorage.getItem("currentPage")),
        },() =>
             this.getUserActivities(this.state.offset, this.state.perPage)
        );
        }else{
                this.setState({
            offset:0,
            perPage:50,
            currentPage:0
        },() =>
             this.getUserActivities(this.state.offset, this.state.perPage))
        }
        this.setState({
            loaderFlag: true,
        });
        var self = this;
        // this.apiserve.sendevent("admin|getUseranalytics", { "tab": 2 });
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|getUseranalytics":
                    if (!response.error) {
                        // count=0
                        count = response.data.totalScan
                        notScannedcount = 0
                        this.setState({
                            getAllUserActivities: response.data.docs,
                            // counts: response.data.docs.map((item)=>{
                            //     if (item.isScanned)  count  ++
                            //    }),
                             counts:count,
                            notcounts: response.data.docs.map((item)=>{
                                if (item.isScanned === false)  notScannedcount  ++
                               }),
                            getTotalDocs: response.data.totalDocs,

                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            loaderFlag: false,
                            // totalPages: response.data.totalPages || 0
                        }, () => {
                            this.setState({
                              
                                dateTimeFilterModal: false
                            })
                        })
                       } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                    case 'admin|getFilmTitles':

                        if (!response.error) {

                            let FilmTypeFilterDatas = response.data.map((item,i)=>{
                                return ({
                                    'name': item.title,
                                    'id': item._id,
                                    // 'value' : false,
                                    'assign':i+1
                                })                                
                            })
                            this.setState({
                                // FilmTypeFilterData: FilmTypeFilterDatas,
                                OrignalData:FilmTypeFilterDatas,                               
                            }, () => {
                                this.setState({
                                  
                                    dateTimeFilterModal: false
                                })
                            })
                           } else {
                            this.apiserve.error(response.data.error ? response.data.error : response.data)
                        }
                        
                            break;
                    case 'location|exploreList':
                        if (!response.error) {
                             let locationsFilters = response.data.map((item,i)=>{
                                return ({
                                    'name': item.name,
                                    'id': item._id,
                                    // 'value' : false,
                                    'assign':i+1
                                })                                
                            })
                            // locationFilter = [...new Map(locationFilter.map(item => [item.id, item])).values()];
                            this.setState({
                                // locationFilter:locationsFilters,
                                LocationData:locationsFilters,
                                // loaderFlag: false,
                            })
                        }
                            else {
                                this.apiserve.error(response.data.error ? response.data.error : response.data)
                            }
                        
                            break;
                            case 'admin|getScannedCount':
                                if (!response.error) {
                                  let ScanCount = response.data
                                  this.setState({scancount:ScanCount})
                                   
                                }
                                    else {
                                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                                    }
                                
                                    break;
                    case 'admin|getUseranalytics':
                        if (!response.error) {
                            this.setState({
                                // getAllUserActivities: response.data.docs,
                                getTotalDocs: response.data.totalDocs,
                                loaderFlag: false,
                                // pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                                // totalPages: response.data.totalPages || 0
                                // }, () => {
                                //     this.setState({
                                //         loaderFlag: false,
                                //         dateFilterModal: false
                                //     })
                            })
                        } else {
                            this.apiserve.error(response.data.error ? response.data.error : response.data)
                        }
                        break;
            }
        });
    }


    getUserActivities = (skip, limit) => {
        this.setState({ count:0 })
        var data = {}
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        if (this.state.searchFilmField.length) {
            data.filmFilter = this.state.searchFilmField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }
        if (FilmTypeFilterData.length) {
            data.film = FilmTypeFilterData
        }
        if(locationFilter.length) {
            data.location = locationFilter
        }
        data.page = skip
        data.limit = limit
        data.tab = 2
        this.setState({loaderFlag:true})
        this.apiserve.sendevent("admin|getUseranalytics", data);
        this.apiserve.sendevent("admin|getScannedCount", {});
      
        
       
    }


    clearDateFilter = () => {
     
        this.setState({ loaderFlag: true,TheaterDatetimeFlag:false, Datetime: false })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }
        if (screeningTypeFilterData.length) {
            data.location = locationFilter
        }

        data.page = 1
        data.limit = 50
        data.tab = 2
        this.apiserve.sendevent("admin|getUseranalytics", data);
        this.apiserve.sendevent('location|exploreList',{})
        this.apiserve.sendevent("admin|getFilmTitles", {});
    }

    //Pagination Click
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true,
                count : 0
            },
            () => {
                localStorage.setItem('currentPage',this.state.currentPage)
                localStorage.setItem('offset',offset)
                localStorage.setItem('perPage',this.state.perPage)
                this.getUserActivities(offset, this.state.perPage, roleWiseFilterData);
            }
        );
    };

    //role wise filter
    roleWiseFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let roleList = [...this.state.rolesType]
        roleList.forEach((key, i) => {
            if (i === index) {
                roleList[i].value = event
            }
            if (isClearRoleType) {
                roleList[i].value = false
                roleWiseFilterData = []
            }

        })
        this.setState({
            ...this.state,
            count:0,
            rolesType: roleList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    roleWiseFilterData = [...roleWiseFilterData, this.state.rolesType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = roleWiseFilterData.filter((d) => d !== this.state.rolesType[index].assign);
                    roleWiseFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType, isClearItemType);
        })
    };
    //role wise filter
    LocationFilterdata =  (e, selectedInex, isClearRoleType,isClearLocationType=false) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let LocationList = [...this.state.LocationData]
        let LocationDatad=[...this.state.LocationData]
        var Arr = []
        LocationDatad.forEach((loca) => {
           
            if (loca.id === index) {
                loca.value = event
            }


            if (isClearLocationType) {
                loca.value = false
                // location.value = false
                locationFilter = []
            }
            Arr.push(loca)

        })

        this.setState({
            ...this.state,
            count:0,
            locationFilter: Arr,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    locationFilter = [...locationFilter, index];

                }
            } else {
                if (index !== null) {
                    let tempArray = locationFilter.filter((d) => d !== index);
                    locationFilter = tempArray;
                }
            }
            // this.setState({})
            this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType,isClearLocationType);
        })
    };
    FilmTypeFilter =  (e, filmId, isClearRoleType, isClearItemType,isClearFilmItemType=false) => {
      let index = filmId
      
      
        let event = e && e.target && e.target.checked
        let filmList = [...this.state.OrignalData]
        let OrginalList = [...this.state.OrignalData]
        var Arr = []
         OrginalList.forEach((film,i) => {
            if (film.id === index) {
                film.value = event
            }


            if (isClearFilmItemType) {
                film.value = false
                FilmTypeFilterData = []
            }
            Arr.push(film)

        })

        if (isClearFilmItemType) {
            this.props.dispatch({type: 'Searchvalue', res: ''})
             this.setState({
                searchFilm : ''
            }, () => { this.setState({ searchFilm: '' }) })
         }
        this.setState({
            ...this.state,
            count:0,
            FilmTypeFilterData: Arr,
            currentPage: 0
        }, () => {
          if (event) {
                if (index !== null) {
                   
                    FilmTypeFilterData = [...FilmTypeFilterData, index];
                }
            } else {
                if (index !== null) {
                    let tempArray = FilmTypeFilterData.filter((d) => d !== index);
                    FilmTypeFilterData = tempArray;
                }
            }
            // this.setState({})
            this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType, isClearItemType,isClearFilmItemType);
        })
    };
    //Screening tyep filter
    screeningTypeFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let screeningList = [...this.state.screeningType]
        screeningList.forEach((key, i) => {
            if (i === index) {
                screeningList[i].value = event
            }
            if (isClearItemType) {
                screeningList[i].value = false
                screeningTypeFilterData = []
            }

        })
        this.setState({
            ...this.state,
            count:0,
            screeningType: screeningList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    screeningTypeFilterData = [...screeningTypeFilterData, this.state.screeningType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = screeningTypeFilterData.filter((d) => d !== this.state.screeningType[index].assign);
                    screeningTypeFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    };


    getAllItemFilter = (skip, limit, isClearRoleType, isClearItemType) => {
       this.setState({ loaderFlag: true,count:0, })
        var data = {
            page: 1,
            limit: 50
        }

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }
        if (FilmTypeFilterData.length) {
            data.film = FilmTypeFilterData
        }
        if (locationFilter.length) {
            data.location = locationFilter
            // data.location = []
        }

        if (this.state.Datetime) {
            let fromDate = new Date(this.state.fromDate)
            let toDate = new Date(this.state.toDate)

            fromDate.setHours(0)
            fromDate.setMinutes(0)
            toDate.setHours(23)
            toDate.setMinutes(59)
            data.fromDate = fromDate
            data.toDate = toDate
        }
        data.tab = 2
        this.apiserve.sendevent("admin|getUseranalytics", data);
        
    }
    OpenTheaterDatetimeDateFilter=()=>{
        this.setState({
           dateTimeFilterModal: true
       })
   }
    DatetimecloseModal=()=>{
        this.setState({
            dateTimeFilterModal: false,
        })
    }
    TheaterDatetimeclearDateFilter=()=>{
        this.setState({ loaderFlag: true, TheaterDatetimeFlag: false, Datetime: false })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }
        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }
        if (FilmTypeFilterData.length) {
            data.film = FilmTypeFilterData
        }
        if (locationFilter.length) {
            data.location = locationFilter
            // data.location = []
        }

        // if (itemsWiseFilterData.length) {
        //     data.pass = itemsWiseFilterData
        // }

        data.page = 1
        data.limit = 50
        data.tab = 2
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }
    TheaterDatetimeclearDateFilter=()=>{
        this.setState({ loaderFlag: true, TheaterDatetimeFlag: false, Datetime: false })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }
        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }
        if (FilmTypeFilterData.length) {
            data.film = FilmTypeFilterData
        }
        if (locationFilter.length) {
            data.location = locationFilter
            // data.location = []
        }
        // if (itemsWiseFilterData.length) {
        //     data.pass = itemsWiseFilterData
        // }

        data.page = 1
        data.limit = 50
        data.tab = 2
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }
    getMtTime=(date)=>{
        //Get offset from mountain time using UTC
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);

        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }
    TheaterdateFilter=(from, to)=>{
        this.setState({ loaderFlag: true, TheaterDatetimeFlag: true })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }
        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }
        if (FilmTypeFilterData.length) {
            data.film = FilmTypeFilterData
        }
        if (locationFilter.length) {
            data.location = locationFilter
            // data.location = []
        }

        // if (itemsWiseFilterData.length) {
        //     data.pass = itemsWiseFilterData
        // }
        let fromDate = new Date(from)
        let toDate = new Date(to)
        // fromDate.setHours(0)
        // fromDate.setMinutes(0)
        // toDate.setHours(23)
        // toDate.setMinutes(59)
        //  fromDate =moment(from).utc().toISOString()
        // toDate = moment(to).utc().toISOString()
        

        data.page = 1
        data.limit = 50
        data.tab = 2
        data.fromDate =this.getMtTime(from)
        data.toDate = this.getMtTime(to) 
        this.apiserve.sendevent("admin|getUseranalytics", data);
        this.setState({ Datetime: true })
    }
    TheaterdateChangeForm=(e)=>{

        this.setState({
            fromDate: e
        })
    }
    TheaterdateChangeTo=(e)=>{
        this.setState({
            toDate: e
        })
    }
     //Search Data 
     onSearchFilters = (e) => {
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }
        const { name, value } = e.target
        const Value = value
        let self = this
        this.setState({
            [e.target.name]: e.target.value,
            currentPage:0,
        });
        this.setState({loaderFlag:true})
        this.setState({
            typing: false,
            typingTimeout: setTimeout(function () {
                var data = {}
                if (Value.length) {
                    data = {
                        page: 1,
                        limit: 50,
                        filmFilter: Value,
                    }
                }
                if (self.state.searchFilmField.length) {
                    data.filmFilter = self.state.searchFilmField
                 }
                 data.tab = 2
                 data.limit=50
                 self.apiserve.sendevent("admin|getUseranalytics", data);
            },1500)
    })}
   // search OrignalData
    // onSearchfilmFilters = (e) => {
    //     const {name,value}= e.target
    //  this.setState({searchFilm:value})
    // this.props.dispatch({type: 'Searchvalue', res: value})
    // let olddata = this.state.OrignalData.filter((item)=> {
    //   return item.name.toLowerCase().includes(this.props.Searchvalue.toLowerCase()) 
    // })
    //  this.setState({OrignalData:olddata})
    //  this.forceUpdate()
    //  if(value === ''){
    //     this.apiserve.sendevent("admin|getFilmTitles", {});
    //  }
    // }
    // onSearchlocationFilters = (e) => {
    //     const {name,value}= e.target
    //  this.setState({searchLocation:value})
    // this.props.dispatch({type: 'searchLocation', res: value})
    // let olddata = this.state.LocationData.filter((item)=> {
    //   return item.name.toLowerCase().includes(this.props.searchLocation.toLowerCase()) 
    // })
    //  this.setState({LocationData:olddata})
    //  this.forceUpdate()
    //  if(value === ''){
    //     this.apiserve.sendevent("location|exploreList", {});
    //  }
    // }
    
    render() {
        const { closeModal,OpenTheaterDatetimeDateFilter,TheaterDatetimeclearDateFilter,TheaterDatetimeFlag,dateTimeFilterModal,itemsTypeFilter,TheaterdateChangeForm,TheaterdateChangeTo,TheaterdateFilter,DatetimecloseModal,dateStringLabelTheaterDatetime,fromDate,toDate, FilmTypeFilter,OrignalData,screeningTypeFilter,screeningType, LocationData,LocationFilterdata,onSearchfilmFilters,onSearchlocationFilters,searchFilm,searchLocation, onSearchFilters,roleWiseFilterData,roleWiseFilter} = this.props
        const {  rolesType,getTotalDocs,itemsWiseFilterData, dateStringLabel, getAllUserActivities,  dateFilterModal, sprofileName, } = this.state
        // let dateStringLabelTheaterDatetime = `${moment(this.state.fromDate).format('MM/DD/YYYY')} - ${moment(this.state.toDate).format('MM/DD/YYYY')}`;
        return (
            <>
                <div className="dashboard_data">
                {/* <div style={{width: "325px"}}>
                                <div class="dashboard_header no_bg p_0" style={{width:"1500px"}}>
                                    <div class="searchBlock back_date pl_15" style={{maxWidth:"none"}}>
                                        <form class="m_0">
                                            <input class="bg_white" type="text" placeholder="Search" id="searchFilmField" name="searchFilmField"  value={this.state.searchFilmField}
                                                onChange={onSearchFilters}  />
                                            <button type="button" ><img src={serachIcon} /></button>
                                        </form>
                                        {/* <span  style={{color:"#000000",marginLeft:"10px"}}>Scanned (Filtered) - {count} /&nbsp;{ notScannedcount}</span> 
                                        <span  style={{color:"#000000",marginLeft:"10px"}}> ( { count ?count:'0'} /&nbsp;{ getTotalDocs?getTotalDocs:'0'})</span>
                                    </div>
                                </div>
                            </div> */}
                    <table>
                       
                        <thead>
                            <th style={{ width: "222px" }} className="pl_25"><span>Email</span></th>
                            <th style={{ width: "90px" }}><span>First Name</span></th>
                            <th style={{ width: "90px" }}><span>Last Name</span></th>
                            <th style={{ width: "120px" }}>
                                <span className="d_flex d_flex_align_center">
                                    Role
                                    {/* {roleWiseFilterData && roleWiseFilterData.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    } */}
                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">

                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => roleWiseFilter(null, null, true, null)}>Clear All</p>
                                                </div>
                                               
                                                {rolesType.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item.name}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => roleWiseFilter(e, i)}
                                                        />
                                                        <label htmlFor={item.name}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "130px" }}>
                                <span>Film
                             {FilmTypeFilterData && FilmTypeFilterData.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }

                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => FilmTypeFilter(null, null, null, null,true)}>Clear All</p>
                                                </div>
                                                <div class="dashboard_header no_bg p_0">
                                                <div class="searchBlock back_date pl_15">
                                        <form class="m_0">
                                            <input class="bg_white" type="text" placeholder="Search" id="searchFilm" name="searchFilm"  value={searchFilm}
                                                onChange={onSearchfilmFilters}  />
                                                <button type="button" ><img src={serachIcon} /></button>
                                        </form>
                                        </div>
                                    </div>
                                                {OrignalData.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={ `film_${item.id}`}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => FilmTypeFilter(e, item.id)}
                                                            />
                                                        <label htmlFor={ `film_${item.id}`}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "160px" }}>
                                <span className="d_flex d_flex_align_center">
                                    Screening Type
                                    {screeningTypeFilterData && screeningTypeFilterData.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }
                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => screeningTypeFilter(null, null, null, true)}>Clear All</p>
                                                </div>
                                               
                                                {screeningType.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item.name}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => screeningTypeFilter(e, i)}
                                                        />
                                                        <label htmlFor={item.name}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "120px" }}>
                                <span>Locations {locationFilter && locationFilter.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }
                                    </span>
                                    <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => LocationFilterdata(null, null, null,true)}>Clear All</p>
                                                </div>
                                                <div class="dashboard_header no_bg p_0">
                                                <div class="searchBlock back_date pl_15">
                                        <form class="m_0">
                                            <input class="bg_white" type="text" placeholder="Search" id="searchLocation" name="searchLocation"  value={searchLocation}
                                                onChange={onSearchlocationFilters}  />
                                                <button type="button" ><img src={serachIcon} /></button>
                                        </form>
                                        </div>
                                    </div>
                                                {LocationData.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={ `location_${item.id}`}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => LocationFilterdata(e, item.id)}
                                                        />
                                                        <label htmlFor={ `location_${item.id}`}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                       
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: TheaterDatetimeFlag ? "230px" : "190px" }} className="text_center">
                                {TheaterDatetimeFlag ?
                                    <>
                                        <span className="pointer date_filter_btn" >
                                            {dateStringLabelTheaterDatetime}
                                        </span>
                                        <p onClick={TheaterDatetimeclearDateFilter} className="text_right mt_5 blue pointer">Clear</p>
                                    </>
                                    :
                                    <span className="pointer date_filter_btn" onClick={OpenTheaterDatetimeDateFilter}>Date/Time (MT)</span>
                                }
                            </th>
                            {/* <th style={{ width: "120px" }}>
                                <span>Date/Time (MT)</span>
                            </th> */}
                            <th style={{ width: "140px" }}>
                                <span>Purchase Date Time (MT)</span>
                            </th>
                            <th style={{ width: "90px" }}>
                                <span>Product</span>
                            </th>
                            <th style={{ width: "120px" }}>
                                <span>Scanned</span>
                            </th>
                        </thead>
                        <tbody>
                            {getAllUserActivities.map((getUserActivity, i) => {
                                return (
                                    <tr>
                                        <td style={{ width: "222px" }} className="pl_25">{getUserActivity && getUserActivity.userId && getUserActivity.userData.email}</td>
                                        <td style={{ width: "110px" }}>{getUserActivity && getUserActivity.userId && getUserActivity.userData.fname}</td>
                                        <td style={{ width: "110px" }}>{getUserActivity && getUserActivity.userId && getUserActivity.userData.lname}</td>
                                        <td style={{ width: "120px" }}>{getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'sioUser' ? 'Industry User' :
                                            getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'pressUser' ? 'Press User' :
                                                getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'circleGuestUser' ? 'Sundance Guest' :
                                                    getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'generalUser' ? 'General User' :
                                                        getUserActivity && getUserActivity.userId && getUserActivity.userData.role === 'artistUser' ? 'Artist User' : '-'}</td>
                                         <td style={{ width: "110px" }}>{getUserActivity && getUserActivity.userId && getUserActivity.filmDetail.isShortProgramme === true ? getUserActivity.filmDetail.name: getUserActivity.filmDetail.title}</td>
                                        <td style={{ width: "110px" }}>
                                            {getUserActivity.filmDetail.dateTime.screeningType === "1" ? 'Premiere' :
                                                getUserActivity.filmDetail.dateTime.screeningType === "2" ? 'Second Screening' :
                                                    getUserActivity.filmDetail.dateTime.screeningType === "3" ? 'Award winner':
                                                    getUserActivity.filmDetail.dateTime.screeningType === "4" ? 'Private Screening' : '-'}
                                        </td>
                                       
                                        <td style={{ width: "110px" }}> {getUserActivity && getUserActivity.filmDetail.dateTime.locations.length==0?"-": getUserActivity.filmDetail.dateTime.locations[0].name} </td>
                                        <td style={{ width: "140px" }}> {moment(getUserActivity.filmDetail.dateTime.date).tz("US/Mountain").format('MM/DD/YYYY')} {moment(getUserActivity.filmDetail.dateTime.date).tz("US/Mountain").format('h:mm A')}</td>
                                        <td style={{ width: "140px" }}> {moment(getUserActivity.createdAt).tz("US/Mountain").format('MM/DD/YYYY')} {moment(getUserActivity.createdAt).tz("US/Mountain").format('h:mm A')}</td>
                                        <td>
                                            {getUserActivity.passIdentifier === "hybridAllAccessPass"
                                                ? "All Access Pass"
                                                : getUserActivity.passIdentifier === "hybridAllAccessPassFirstHalf"
                                                    ? "All Access Pass 1st half Pass "
                                                    : getUserActivity.passIdentifier === "hybridAllAccessPassSecondHalf"
                                                        ? "All Access Pass 2nd half Pass "
                                                        : getUserActivity.passIdentifier === "onlineAllAccessPass"
                                                            ? "All Access Pass - Online only "
                                                            : getUserActivity.passIdentifier === "hybridPressIndustryPackage"
                                                                ? "P&I Package "
                                                                : getUserActivity.passIdentifier === "onlinePressIndustryPackage"
                                                                    ? "P&I Package - Online only "
                                                                    : getUserActivity.passIdentifier === "hybridFestivalPass"
                                                                        ? "Festival Package "
                                                                        // : getUserActivity.passIdentifier === "onlineFestivalPass"
                                                                        //     ? "OFP "
                                                                        : getUserActivity.passIdentifier === "onlineDayPass"
                                                                            ? "Day Package - Online only "
                                                                            : getUserActivity.passIdentifier === "hybridResortPackage"
                                                                                ? "Resort Package "
                                                                                : getUserActivity.passIdentifier === "saltLackCityPackage"
                                                                                    ? "SLC Package "
                                                                                    : getUserActivity.passIdentifier === "hybridAwardWinnersPass"
                                                                                        ? "Award Winners Weekend "
                                                                                        : getUserActivity.passIdentifier === "hybridSingleFilmTicket"
                                                                                            ? "Single Ticket "
                                                                                            : getUserActivity.passIdentifier === "onlineExplorerPass"
                                                                                                ? "Explorer Pass - Online only "
                                                                                                : ""}</td>
                                        {getUserActivity.isScanned === true ?
                                            <td style={{ width: "140px" }}> {moment(getUserActivity.scannedDate).tz("US/Mountain").format('MM/DD/YYYY')} {moment(getUserActivity.scannedDate).tz("US/Mountain").format('h:mm A')}</td>
                                            :
                                            <td style={{ width: "140px" }}> Not Scanned </td>
                                        }
                                        {/* <td style={{ width: "90px" }}> {getUserActivity.orderId}</td>
                                    <td style={{ width: "140px" }}> ${getUserActivity.total} </td> */}
                                        {/* <td style={{ width: "80px" }}> {getUserActivity && getUserActivity.cartData && getUserActivity.cartData.reduce((n, { quantity }) => n + quantity, 0)} </td> */}
                                        {/* <td style={{ width: "110px" }}> {getUserActivity.discountCode ? getUserActivity.discountCode : '-'} </td> */}
                                        {/* <td style={{ width: "110px" }}> {getUserActivity && getUserActivity.userId && getUserActivity.userId.accountBillingAddress && getUserActivity.userId.accountBillingAddress.zipBilling} </td> */}
                                        {/* <td style={{ width: "110px" }}>{ getUserActivity.paymentMethod}</td> */}

                                        {/* <td style={{ width: "170px" }} className="text_center">
                                        <span className="pointer text_center" >
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7.34844 10.3938L7.35156 10.8891C7.35156 10.9578 7.29531 11.0156 7.22656 11.0156H6.78281C6.71406 11.0156 6.65781 10.9594 6.65781 10.8906V10.4C5.27031 10.2969 4.61719 9.50625 4.54688 8.64688C4.54063 8.57344 4.59844 8.51094 4.67188 8.51094H5.39375C5.45469 8.51094 5.50781 8.55469 5.51719 8.61406C5.59688 9.10938 5.98281 9.47969 6.675 9.57187V7.34219L6.28906 7.24375C5.47188 7.04844 4.69375 6.53906 4.69375 5.48281C4.69375 4.34375 5.55937 3.73125 6.66563 3.62344V3.10781C6.66563 3.03906 6.72188 2.98281 6.79063 2.98281H7.22969C7.29844 2.98281 7.35469 3.03906 7.35469 3.10781V3.61875C8.425 3.72656 9.22812 4.35156 9.32187 5.325C9.32969 5.39844 9.27187 5.4625 9.19687 5.4625H8.49531C8.43281 5.4625 8.37969 5.41563 8.37187 5.35469C8.30937 4.89844 7.94375 4.52656 7.34844 4.44531V6.54375L7.74531 6.63594C8.75781 6.88594 9.44687 7.37031 9.44687 8.45469C9.44687 9.63125 8.57187 10.2875 7.34844 10.3938ZM5.66563 5.41094C5.66563 5.80781 5.91094 6.11562 6.43906 6.30625C6.5125 6.33594 6.58594 6.35938 6.67344 6.38438V4.44688C6.09688 4.52031 5.66563 4.84375 5.66563 5.41094ZM7.48594 7.52344C7.44219 7.51406 7.39844 7.50312 7.34844 7.48906V9.57812C8.01406 9.51875 8.47344 9.15312 8.47344 8.54062C8.47344 8.06094 8.225 7.74844 7.48594 7.52344Z" fill="#5D737E" />
                                            </svg>
                                        </span>
                                    </td> */}
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                </div>
                {/* Pagination View Display */}
                {getAllUserActivities.length && getAllUserActivities ? (
                    <div className="custom-pagination">
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.props.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={this.props.currentPage}
                        />
                    </div>
                ) : (
                    ""
                )}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                    ""
                )}
                {
                    dateTimeFilterModal ?
                        <div className='user_popup active date_time_picker'>
                            <span className="popup_overlay" onClick={this.DatetimecloseModal}></span>
                            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white overflow_initial" >
                                <div className="approve_popup_header text_center relative pb_0">
                                    <span className="close_popup" onClick={this.DatetimecloseModal}>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.192 0.343994L5.949 4.58599L1.707 0.343994L0.292999 1.75799L4.535 5.99999L0.292999 10.242L1.707 11.656L5.949 7.41399L10.192 11.656L11.606 10.242L7.364 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                        </svg>
                                    </span>
                                    <h3 className="mb_10">Select Date Filter { }</h3>
                                </div>
                                <div className="content">
                                    <div className="date_content  d_flex d_flex_justify_center">

                                        <div className="from_date d_flex d_flex_align_center d_flex_justify_center">
                                            <TextField type="text" name="countDownDate" label="From" disabled={true} value={moment(fromDate).format(
                                                "MMM Do, yy h:mm a"
                                            )}
                                                placeholder="MMM Do, yy h:mm a" />

                                            <div className=" ml_10 d_flex d_flex_align_center d_flex_justify_center">
                                                <DatePicker
                                                    selected={fromDate}
                                                    onChange={(e) => TheaterdateChangeForm(e)}
                                                    placeholderText="MMM Do, yy h:mm a"
                                                    // maxDate={new Date()}
                                                    showTimeSelect
                                                    dateFormat="MMM Do, yy h:mm a"
                                                    customInput={
                                                        <span className="calendar">
                                                            <CalendarIcon opacity="1" />
                                                        </span>
                                                    }

                                                />
                                            </div>
                                        </div>
                                        <div className="to_date d_flex d_flex_justify_center">
                                            <TextField type="text" name="countDownDate"  label="To" disabled={true} value={moment(toDate).format(
                                                "MMM Do, yy h:mm a"

                                            )} placeholder="mm / Do / yyyy" />


                                            <div className=" ml_10 d_flex d_flex_align_center d_flex_justify_center">
                                                <DatePicker
                                                    selected={toDate}
                                                    onChange={(e) => TheaterdateChangeTo(e)}
                                                    // maxDate={new Date()}
                                                    placeholderText="MMM Do, yy h:mm a"
                                                    showTimeSelect

                                                    dateFormat="MMM Do, yy h:mm a"                                                    customInput={
                                                        <span className="calendar">
                                                            <CalendarIcon opacity="1" />
                                                        </span>
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_row text_center">
                                        <button className="active" onClick={(e) => TheaterdateFilter(fromDate, toDate)}>Submit </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        ""
                }
            </>
        )
    }
}

export default connect(mapStateToProps)(TheaterDetails);